<template>
    <div>
        <div class='clearfix'></div>
        <div class="ibox animated fadeInRightBig" v-if="!$route.params.operation">
            <div class="ibox-title" style="padding:5px;">
                <h5>
                    {{crudName}}
                    <span class="crud-list-actions" v-show="enableAdd">
                      <router-link :to="detailUrl || endPoint + 'add'" class="btn btn-add">
                        <i class="fa fa-plus"></i> {{newText}}
                      </router-link>
                    </span>
                </h5>
            </div>
            <div class="ibox-content">
                <div class="block m-b-md text-right" v-if="enableAddModal">
                    <button type="button" class="btn btn-success" @click="addModal">Adicionar {{ crudName }}</button>
                </div>
                <v-server-table ref="table" :tableData="tableData" :name="table" :url="url" :columns="columns" :options="options">
                    <div slot="actions" slot-scope="props" class='actions'>
                        <a 
                            v-show="enableDownload" 
                            data-toggle="tooltip" 
                            title="Download" 
                            class="clickable btn btn-info"
                            @click="download(props.row.file)"
                        >
                            <i class="fa fa-download"></i>
                        </a>

                        <a 
                            v-show="enableView" 
                            data-toggle="tooltip" 
                            title="Consultar" 
                            class="clickable btn btn-crud view"
                            @click="view(props.row.id)"
                        >
                            <i class="fa fa-eye"></i>
                        </a>

                        <a 
                            v-show="enableEdit" 
                            data-toggle="tooltip" 
                            title="Editar" 
                            class="clickable btn btn-crud edit"
                            @click="edit(props.row.id)"
                        >
                            <i class="fas fa-pencil-alt"></i>
                        </a>

                        <a 
                            v-show="enableEditModal" 
                            @click="editModal(props.row.id)" 
                            data-toggle="tooltip" title="Editar" 
                            class="clickable btn btn-warning"
                        >
                            <i class="fas fa-pencil-alt"></i>
                        </a>

                        <a 
                            v-show="enableDelete" 
                            data-toggle="tooltip" 
                            title="Deletar"
                            class="clickable btn btn-crud delete" 
                            @click="destroy(props, props.row, props.index)"
                        >
                            <i class="far fa-trash-alt"></i>
                        </a>

                        <template v-for="extra in extra">
                          <a data-toggle="tooltip" :title="extra.title" :key="extra.id"
                           :class="'clickable ' + extra.class" @click="callExtra(extra.name, props, props.row, props.index)"
                            v-if="showExtra(props, extra)"
                           >
                           <i v-if="extra.icon" :class='extra.icon'></i>
                           {{extra.label}}
                          </a>
                        </template>
                    </div>
                    <div slot="photo" slot-scope="props">
                        <img :src="props.row.photo" alt="" width="85px">
                    </div>
                    <div slot="photo_http" slot-scope="props">
                        <img :src="props.row.photo_http" alt="" width="85px">
                    </div>
                    <div slot="cover_photo" slot-scope="props">
                        <img :src="props.row.cover_photo" alt="" class="photo">
                    </div>
                    <div slot="color" slot-scope="props">
                        <div class="box" v-bind:style="{ 'background-color': props.row.color }"></div>
                        <span class="bold">
                            <i class="fas fa-square" :style="'color: ' + props.row.color"></i>
                        </span>
                    </div>
                    <div slot="qrcode" slot-scope="props">
                        <img :src="props.row.qrcode" alt="" class="qrcode">
                        <br>
                        <span class="bold">
                            {{ props.row.qrcode_name }}
                        </span>
                    </div>
                    <div slot="checkbox" slot-scope="props" class='centered'>
                        <input type="checkbox" @click="checkboxSelected(props.row)" :checked="selectedCheckboxIds.includes(props.row.id)">
                    </div>
                    <!-- <div slot="filter__checkbox" class='centered'>
                        <input type="checkbox" v-model="selectAllChbx" @click="selectAll">
                    </div> -->
                </v-server-table>
            </div>
        </div>

        <BaseForm v-if="dataForm" :dataForm="dataForm" @fieldUpdated="fieldUpdated"/>
    </div>
</template>

<script>
    import {Pagination} from 'vue-pagination-2'
    import BaseForm from './BaseForm'

    export default {
        data: function () {
            return {
                records: [],
                pages: [],
                tableData: [],
                selectAllChbx: false,
            }
        },
        props: {
            crudName: String,
            newText: String,
            table: String,
            columns: Array,
            options: Object,
            endPoint: String,
            with: String,
            enableAdd: Boolean,
            enableAddModal:Boolean,
            enableEditModal: Boolean,
            enableEdit: Boolean,
            enableDelete: Boolean,
            enableView: Boolean,
            enableDownload: Boolean,
            extra: Array,
            dataForm: Object,
            selectedCheckboxes: Array,
            detailUrl: String
        },
        mounted() {
            this.enableAddModal  = this.enableAddModal || false;
            this.enableEditModal = this.enableEditModal || false;
        },
        computed: {
            url() {
                return this.$store.getters.api + this.endPoint + (this.with ? this.with : '')
            },
            selectedCheckboxIds: function(){
                let ids = []
                if(Array.isArray(this.selectedCheckboxes)){
                    this.selectedCheckboxes.forEach(x => {
                        ids.push(x.id)
                    })
                }
                return ids;
            }
        },
        methods: {
            fieldUpdated: function(field){
                this.$emit('fieldUpdated', field)
            },
            checkboxSelected(row, force = null){
                this.$emit('checkboxSelected', {'row': row, 'force': force})
            },
            selectAll(e){
                console.log($(e.target).is(":checked"))
                const self = this;
                
                let url = localStorage.getItem('url') + '&paginated=false';
                let requestData = JSON.parse(localStorage.getItem('requestData'))
                
                axios.get(url + (self.with ? self.with : ''), requestData)
                .then(res => {
                    for(let i = 0; i < res.data.data.length; i++){
                        let item = res.data.data[i];
                        self.checkboxSelected(item, self.selectAllChbx)
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            callExtra(name, props, row, index) {
              this.$emit(name, {
                props,row,index
              })
            },
            edit(id) {
                this.$router.push({
                    path: this.detailUrl ? this.detailUrl + '/' + id : this.endPoint + 'edit/' + id
                    
                })
            },
            view(id) {
                this.$router.push({
                    path: this.endPoint + 'view/' + id
                })
            },
            download(file) {
                window.open(file, '_blank');
            },
            destroy(props, row, index) {
                const self = this

                swal({
                    title: "Deseja deletar o registro?",
                    text: "Essa operação não pode ser desfeita",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, deletar!",
                    showLoaderOnConfirm: true,
                    buttons: {
                        catch: {
                            text: "Não",
                            value: "cancel",
                            className: "btn-danger"
                        },
                        confirm: {
                            text: "Sim",
                            value: 'confirm'
                        }
                    },
                })
                    .then((value) => {
                        switch (value) {
                            case 'cancel':
                                swal('Cancelado', 'O registro não foi excluido!', 'info');
                                break;

                            case 'confirm':

                                self.$http.delete(this.url + row.id, {
                                    'id': row.id
                                })
                                    .then((response) => {
                                        self.$refs.table.tableData.splice(index - 1, 1);
                                        swal('Sucesso', 'Registro excluído com sucesso!', 'success');
                                    });
                                break;
                        }
                   })
            },
            addModal: function(){
                this.$emit('addModal');
            },
            editModal: function(id){
                this.$emit('editModal', id);
            },
            showExtra(props, extra){
                if(extra.name == 'advanceResearchStatusId' && props.row.status_id > 8){
                    return false
                } else if(extra.name == 'cancelResearch' && (props.row.status_id > 8 || props.row.status_id == 999)){
                    return false
                } else if(extra.name == 'send' && props.row.total_sents > 0){
                    return false
                } else if(extra.name == 'reSend' && props.row.total_sents == 0){
                    return false
                } else if(extra.name == 'cancelModal' && (props.row.multipleStatus == "Concluído" || props.row.multipleStatus == "Cancelado"))
                    return false

                return true
            }
        },
        components: {
            Pagination,
            BaseForm
        }
    }
</script>

<style scoped>

    .photo {
        max-height: 180px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Base/BaseCrud.vue